import { ChakraProvider } from "@chakra-ui/react";
import axios from "axios";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import { NotificationContainer } from "react-notifications";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "../src/redux/Store";
import "./App.css";
import { SelectedOptionsProvider } from "./context/selectedOptionsContext";
import AppRoutes from "./routes/AppRoutes";
import SessionExpiredModal from "./components/ConfirmationModals/SessionExpiredModal";

function App() {
  const handleLogOut = () => {
    localStorage.clear();
    window.location.href = "/login";
  };

  useEffect(() => {
    moment.tz.setDefault("America/New_York");

    const originalFormat = moment.fn.format;
    moment.fn.format = function (...args) {
      if (!this.isValid()) return ""; 
      return originalFormat.apply(this, args);
    };

    return () => {
      moment.tz.setDefault();
    };
  }, []);

  const [showSessionExpired, setShowSessionExpired] = useState(false);

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        if (error.response?.status === 403) {
          handleLogOut();
        } else if (error.response?.status === 401) {
          setShowSessionExpired(true);
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, []);

  return (
    <ChakraProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <SelectedOptionsProvider>
            <div className="App">
              <AppRoutes />
              <NotificationContainer />
              <SessionExpiredModal showSessionExpired={showSessionExpired} handleLogOut={handleLogOut} onClose={() => setShowSessionExpired(false)} />
            </div>
          </SelectedOptionsProvider>
        </PersistGate>
      </Provider>
    </ChakraProvider>
  );
}

export default App;
